export const breakpoints = {
    smallMin: 'min-width: 600px',
    mediumMin: 'min-width: 940px',
};
